import React from 'react';
import { TableProvider } from '@urbantxt/table';
import { HStack } from '@urbantxt/layout';
import useWindowSize from 'hooks/useWindowSize';

type Props = {
  children: React.ReactNode;
};

/**
 * Mirrors txt-rosie's TableProviderRosie. The package's own default
 * `useWindowSize` is a plain non-reactive getter (no resize listener), which
 * would leave PageDataTable stuck on whichever width it first rendered at —
 * this app already has a real resize-subscribed useWindowSize, so it's
 * injected here instead of relying on the package default.
 */
export default function TableProviderMyTxt({ children }: Props) {
  return (
    <TableProvider
      config={{
        components: { HStack },
        hooks: { useWindowSize },
      }}
    >
      {children}
    </TableProvider>
  );
}
